"use client";
import { ProductType } from "@/app/compare/[product]/page";
import logo from "@/assets/images/brand-mini-logo.svg";
import CommonTitle from "@/components/common/CommonTitle";
import Image from "next/image";
import yesIcon from "@/assets/images/comparison/yes.svg";
import partialIcon from "@/assets/images/comparison/partial.svg";
import noIcon from "@/assets/images/comparison/no.svg";

const logoHolderStyle = "h-[38px] w-[38px] flex items-center justify-center";

const capabilityCellStyle =
  "py-2 px-4 text-[14px] font-normal text-[#202020] leading-5 text-left";
const statusCellStyle = "py-2 px-4 text-center text-[#202020]";


const StatusCell = ({
  cell,
}: {
  cell: { status: "yes" | "partial" | "no"; detail?: string };
}) => {
  return (
    <div className="flex items-center justify-start gap-1">
      <Image src={cell.status === "yes" ? yesIcon : cell.status === "partial" ? partialIcon : noIcon} alt={cell.status === "yes" ? "Feature included" : cell.status === "partial" ? "Partially supported" : "Feature not included"} width={28} height={28} />
      {cell.detail ? (
        <p className="text-[14px] text-[#202020] text-left">
          {cell.detail}
        </p>
      ) : (
        <div className="h-3" />
      )}
    </div>
  );
};

const CompareTableDrop = ({ productInfo }: { productInfo: ProductType }) => {
  const sections = productInfo.compareMatrix?.sections || [];
  if (!sections.length) return null;

  return (
    <section className="pb-12 xl:pb-20">
      <div className="container mx-auto px-4">
        <CommonTitle
          color="#202020"
          fontSizeClass="text-[24px] lg:text-[32px] mb-8 lg:mb-10 text-center"
          fontWeightClass="font-semibold"
          as="h2"
        >
          Competitive Comparison{" "}
          <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
            Matrix
          </span>
        </CommonTitle>
        <div className="space-y-14">
          {sections.map((section) => (
            <div key={section.title}>
              <CommonTitle
                color="#202020"
                fontSizeClass="text-[20px] lg:text-[22px] font-semibold ml-4"
                as="h3"
              >
                {section.title}
              </CommonTitle>
              <div className="compare_product_table_wrapper w-full overflow-x-auto rounded-md">
                <table className="w-full bg-white">
                  <thead>
                    <tr>
                      <th className="w-[45%] px-4 py-3 text-left text-[14px] font-semibold uppercase tracking-wide text-[#781E8F]">
                        CAPABILITY
                      </th>
                      <th className="px-4 py-3 text-center w-[20%]">
                        <div className="flex justify-start">
                          <div className={logoHolderStyle}>
                            <Image
                              className="h-full w-full object-contain"
                              src={logo}
                              alt="Kroolo logo"
                            />
                          </div>
                        </div>
                      </th>
                      <th className="px-4 py-3 text-center w-[30%]">
                        <div className="flex justify-start">
                          <div className={logoHolderStyle}>
                            <Image
                              className="h-full w-full object-contain"
                              src={productInfo.productLogo}
                              alt="Competitor product logo"
                            />
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className=" py-1">
                    {section.rows.map((row, idx) => (
                      <tr
                        key={`${row.capability}-${idx}`}
                        className="border-b border-[#e7e7e7]"
                      >
                        <td className={capabilityCellStyle}>
                          {row.capability}
                        </td>
                        <td className={statusCellStyle}>
                          <StatusCell cell={row.kroolo} />
                        </td>
                        <td className={statusCellStyle}>
                          <StatusCell cell={row.competitor} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompareTableDrop;
